import { OperatingStatusCodes as d } from "../types/search/index.js";
const O = (e) => {
  var s, p;
  const u = new RegExp(
    (e == null ? void 0 : e.operatingStatusCodeOverride) ?? (e == null ? void 0 : e.operatingStatusCode) ?? "",
    "i"
  );
  return !!(d.Open.match(u) && ((s = e == null ? void 0 : e.marketedFacilityHours) != null && s.every((r) => (r == null ? void 0 : r.open) === "00:00")) && ((p = e == null ? void 0 : e.marketedFacilityHours) != null && p.every((r) => (r == null ? void 0 : r.close) === "23:59")));
};
export {
  O as g
};
